const apiBase = (
  process.env.VUE_APP_API_URL || "http://localhost:3000"
).replace(/\/api\/v1\/?$/, "");

export function resolveLogoUrl(logoUrl) {
  if (!logoUrl) return null;
  if (logoUrl.startsWith("http")) return logoUrl;
  return `${apiBase}${logoUrl}`;
}
